<template>
  <div>
    <div v-if="isMulti">
      <el-upload
        action="#"
        :file-list="fileList"
        :on-success="onSuccess"
        list-type="picture-card"
        :http-request="fileUpLoad"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :on-error="handleError"
      >
        <slot><i class="el-icon-plus"></i></slot>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <div v-else>
      <el-upload
        class="avatar-uploader"
        action="#"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
        :on-success="onSuccess"
        :http-request="fileUpLoad"
      >
        <img v-if="imageUrl || url" :src="imageUrl || url" class="avatar" />
        <slot v-else><i class="el-icon-plus avatar-uploader-icon"></i></slot>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { getAliOssSts } from '@/components/file-upload/api'
import ossClient, { getFilePath, getSystemPath } from './oss'
import { localget, localset } from '@/utils/localStorage'
import * as imageConversion from 'image-conversion'
import { Loading } from 'element-ui'
export default {
  name: 'FileUpload',
  // isMulti:是否上传多张；name：文件名，url：文件链接
  // 如果isMulti==true, name和url应该是个数组，否则为字符串
  props: ['isMulti', 'name', 'url'],

  data() {
    return {
      // 单张图片的封面
      imageUrl: '',
      // 多张图片的封面
      fileList: [],
      // oss上传配置项
      uploadConf: {},
      // 多张图片预览dialog
      dialogImageUrl: '',
      dialogVisible: false,
      list: [],
      loading: null,
    }
  },
  watch: {
    url: {
      handler(newV, oldV) {
        // 如果是多张图片
        if (this.isMulti) {
          if (newV) {
            // 当监视到url有新值时给fileList赋值初始值
            this.fileList = newV.map((item, index) => {
              return {
                url: item,
                name: this.name.find((name, i) => index == i)
              }
            })
            this.list = this.fileList
          }
        } else {
          this.imageUrl = newV
        }
      },
      immedate: true
    }
  },
  mounted() {
    this.uploadConf = localget('alioss')
    if (!this.uploadConf || !this.uploadConf.domain) {
      getAliOssSts().then(res => {
        this.uploadConf = {
          region: 'oss-cn-hangzhou',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucket,
          stsToken: res.securityToken,
          domain: res.domain,
        }
        localset('alioss', this.uploadConf, 1800)
      })
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024
      return new Promise((resolve, reject) => {
        this.loading = Loading.service({
          lock: true, //是否锁定屏幕的滚动
          spinner: 'el-icon-loading',
          text: '上传中', //loading下面的文字
          background: 'rgba(0, 0, 0, 0.0)', //loading的背景色
          target: 'body' //loading显示在容器
        })
        if (isLt2M < 6) {
          // 小于6M不用压缩
          resolve(file)
        } else {
          //6140kb
          imageConversion.compressAccurately(file, 3072).then(res => {
            console.log('大于6M进行压缩', res)
            resolve(res)
          })
        }
      })
    },
    onSuccess(res, file, filelist) {
      if (this.loading) {
        this.loading.close()
      }
      if (this.isMulti) {
        this.fileList = filelist
        this.list.push({
          url: this.uploadConf.domain + "/" + res.name,
          name: res.name,
          fileUid: file.uid
        })
        const nameList = this.list.map(item => {
          return item.name
        })
        this.$emit('fileUpload', this.list)
        this.$emit('update:name', nameList)
      } else {
        this.imageUrl = this.uploadConf.domain + "/" + res.name
        const uploadInfo =  {
          url: this.imageUrl,
          name: res.name,
          fileUid: file.uid
        }
        this.file = {
          ...uploadInfo
        }
        this.$emit('fileUpload', uploadInfo)
        this.$emit('update:name', this.file.name)
      }
    },
    handleError() {
      if (this.loading) {
        this.loading.close()
      }
    },
    //上传文件操作，调用阿里云
    fileUpLoad(option) {
      //提前拼接返回地址
      let filePath = getFilePath(this.$route.name, option.file.name)
      if (option.file.size > 6291456) {
        this.$message.error('资源文件大小超出范围')
        return
      }
      return ossClient(this.uploadConf).put(filePath, option.file)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.list = this.fileList
      const nameList = this.list.map(item => {
        return item.response ? item.response.name : item.name
      })
      this.$emit('update:name', nameList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader  ::v-deep .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
